// Aggregate field warning rules from category JSON files into a single array
// Keep JSON imports to preserve runtime authoring via JSON files.
// @ts-expect-error allow JSON import without types
import income from './income.json';
// @ts-expect-error allow JSON import without types
import fixedExpenses from './fixed-expenses.json';
// @ts-expect-error allow JSON import without types
import flexibleExpenses from './flexible-expenses.json';
// @ts-expect-error allow JSON import without types
import assets from './assets.json';
// @ts-expect-error allow JSON import without types
import debts from './debts.json';

// Export a flat array to match previous fieldWarningRules.json shape
const fieldWarningRules: any[] = [
  ...(income as any[]),
  ...(fixedExpenses as any[]),
  ...(flexibleExpenses as any[]),
  ...(assets as any[]),
  ...(debts as any[]),
];

export default fieldWarningRules;


